import React, { useContext, useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Label,
  Modal,
  Row,
} from "reactstrap"
import CredContext from "./Creds"
import { useFormik } from "formik"
import * as Yup from "yup"
import LoadingOverlay from "react-loading-overlay"
import GroupCred from "./GroupCred"
import GroupFlexCred from "./GroupFlexCred"
import Success from "pages/NotificationModal/Success"
import Error from "pages/NotificationModal/Error"
import Cookies from "js-cookie"

function CredForm({ appt_sys, isEdit, onCancel }) {
  const {
    fetchAllApptSys,
    formLoading,
    create,
    update,
    fetchCreds,
    success,
    setSuccess,
    apptSysTypes,
    error,
    msg,
    remove,
    createFlexCred,
    updateFlexCred,
    removeFlexCred,
  } = useContext(CredContext)

  const [apptSysName, setApptSysName] = useState(appt_sys?.appt_sys || null)

  const [isGroupCred, setIsGroupCred] = useState(
    appt_sys?.has_cred_group || false
  )

  const [creds, setCreds] = useState([])
  const [updateCreds, setUpdateCreds] = useState([])
  const [deleteCreds, setDeleteCreds] = useState([])

  const [showSuccess, setShowSuccess] = useState(false)
  const [showError, setShowError] = useState(false)
  const [errorMsg, setErrorMsg] = useState(0)

  useEffect(() => {
    fetchAllApptSys()
    if (appt_sys && appt_sys.creds) {
      console.log("apptSys in cred data --> ", appt_sys)
      console.log(appt_sys.creds)

      // Extract default credentials (non-object fields at root level)
      const defaultCreds = Object.entries(appt_sys.creds)
        .filter(([, value]) => typeof value !== "object" || value === null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

      const result = [
        {
          group_name: "default",
          ...defaultCreds,
        },
        // Extract group credentials (object fields)
        ...Object.entries(appt_sys.creds)
          .filter(([key, value]) => typeof value === "object" && value !== null)
          .map(([group_name, credentials]) => ({
            group_name,
            ...credentials,
          })),
      ]
      setCreds(result)
    }
  }, [])

  console.log(apptSysTypes)

  const options = [
    {
      label: "RETALIX",
      value: "RETALIX",
    },
    {
      label: "OPENDOCK",
      value: "OPENDOCK",
    },
    { label: "WALMART_APP_SYS_RL", value: "WALMART_APP_SYS_RL" },
    { label: "RETAILLINK", value: "RETAILLINK" },
  ]

  const handleSelectGroup = event => {
    setApptSysName(event.target.value)
  }

  // Transform credentials for flexible cred fields (dynamic fields)
  const transformFlexCredentials = creds => {
    return creds.reduce((acc, group) => {
      const { group_name, originalCreds, cred_type, ...credentialFields } = group;

      // Filter out masked passwords using the marker fields
      // Marker fields are named like "__masked_password", "__masked_apiKey", etc.
      const filteredFields = Object.entries(credentialFields).reduce((fields, [key, value]) => {
        // Skip marker fields themselves
        if (key.startsWith('__masked_')) {
          return fields;
        }

        // Check if this field has a corresponding mask marker
        const isMasked = credentialFields[`__masked_${key}`] === true;

        // Only include field if it's NOT marked as masked
        if (!isMasked) {
          fields[key] = value;
        }

        return fields;
      }, {});

      if (group_name === "default") {
        Object.assign(acc, filteredFields);
        if (originalCreds) {
          acc.originalCreds = originalCreds;
        }
      } else {
        acc[group_name] = { ...filteredFields };
        if (originalCreds) {
          acc[group_name].originalCreds = originalCreds;
        }
      }
      return acc;
    }, {});
  };

  // Transform credentials for legacy userId/password fields
  const transformCredentials = creds => {
    return creds.reduce((acc, group) => {
      if (group.group_name === "default") {
        acc.userId = group.userId;
        acc.password = group.password;
        if ('originalCreds' in group) {
          acc.originalCreds = group.originalCreds;
        }
      } else {
        acc[group.group_name] = {
          userId: group.userId,
          password: group.password,
        };
        if ('originalCreds' in group) {
          acc[group.group_name].originalCreds = group.originalCreds;
        }
      }
      return acc;
    }, {});
  }
  
  // New save function for flexible credentials
  const saveFlexCredentials = async () => {
    console.log("Saving flexible credentials....")

    // Get password field names from cred_fields to send to backend
    const selectedApptSys = (apptSysTypes || []).find(x => x.key === apptSysName);
    const passwordFields = (selectedApptSys?.cred_fields || [])
      .filter(field => field.type === "password")
      .map(field => field.name);

    const obj = {
      appt_sys: apptSysName,
      createdBy: Cookies.get("email"),
      password_fields: passwordFields,
    }

    let result
    if (isEdit) {
      result = transformFlexCredentials(updateCreds)
    } else {
      result = transformFlexCredentials(creds)
    }

    const del_obj = { ...obj, attribs: deleteCreds }
    obj.attribs = result

    if (isEdit) {
      try {
        let response_upd, response_del;

        if (updateCreds && updateCreds.length > 0) {
          response_upd = await updateFlexCred(obj);
        }

        if (deleteCreds && deleteCreds.length > 0) {
          response_del = await removeFlexCred(del_obj);
        }

        if (response_upd && response_del) {
          if (response_upd.data && response_del.data) {
            setShowSuccess(true);
          } else if (response_upd.error || response_del.error) {
            setShowError(true);
            setErrorMsg(response_upd.error || response_del.error);
          }
        } else if (response_upd) {
          if (response_upd.data) {
            setShowSuccess(true);
          } else if (response_upd.error) {
            setShowError(true);
            setErrorMsg(response_upd.error);
          }
        } else if (response_del) {
          if (response_del.data) {
            setShowSuccess(true);
          } else if (response_del.error) {
            setShowError(true);
            setErrorMsg(response_del.error);
          }
        }
      } catch (error) {
        setShowError(true);
        setErrorMsg(error.message);
      }
    } else {
      let response = await createFlexCred(obj)
      if (response.data) {
        setShowSuccess(true);
      } else if (response.error) {
        setShowError(true)
        setErrorMsg(response.error)
      }
    }
  }

  // Original save function for legacy userId/password credentials
  const save = async () => {
     console.log("Saving....")
    if (!apptSysName) {
      setShowError(true)
      setErrorMsg("Please select appointment system")
      return
    }

    // Check if current appointment system uses flexible credentials
    const selectedApptSys = (apptSysTypes || []).find(x => x.key === apptSysName);
    const usesFlexCreds = selectedApptSys?.cred_fields?.length > 0;

    // Route to appropriate save function
    if (usesFlexCreds) {
      return saveFlexCredentials();
    }

    // Legacy userId/password save logic
    var obj = {
      appt_sys: apptSysName,
      createdBy: Cookies.get("email"),
    }
    let result = transformCredentials(isEdit ? updateCreds : creds);

    var del_obj = { ...obj, attribs: deleteCreds}
    obj = { ...obj, attribs: result }

    if (isEdit)   
    {
    try {
      let response_upd, response_del;

      if (updateCreds && updateCreds.length > 0) {
        response_upd = await update(obj);
      }
  
      if (deleteCreds && deleteCreds.length > 0) {
        response_del = await remove(del_obj);
      }
  
      if (response_upd && response_del) {
        if (response_upd.data && response_del.data) {
          setShowSuccess(true);
        } else if (response_upd.error || response_del.error) {
          setShowError(true);
          setErrorMsg(response_upd.error || response_del.error);
        }
      }
      else if (response_upd) {
        if (response_upd.data) {
          setShowSuccess(true);
        } else if (response_upd.error) {
          setShowError(true);
          setErrorMsg(response_upd.error);
        }
      }
      else if (response_del) {
        if (response_del.data) {
          setShowSuccess(true);
        } else if (response_del.error) {
          setShowError(true);
          setErrorMsg(response_del.error);
        }
      }
    } catch (error) {
      setShowError(true);
      setErrorMsg(error.message);
    }
    }
   else {
      let response = await create(obj)
      if (response.data) {
        setShowSuccess(true);
      }
      else if (response.error) {
        setShowError(true)
        setErrorMsg(response.error)
      }
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      apptSysName: appt_sys?.appt_sys || null,
      has_cred_group: appt_sys?.has_cred_group || false,
      userId: appt_sys?.creds.userId || "",
      password: appt_sys?.creds.password || "",
      retype: appt_sys?.creds.password || "",
    },
    validationSchema: Yup.object({
      apptSysName: Yup.string().required("Please Enter Your first name"),
      userId: Yup.string().required("Please Enter user id"),
      password: Yup.string()
        .min(1, "Password must be at least 1 character long")
        .required("Please enter password"),
      retype: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),

    onSubmit: values => {
      save()
    },
  })

  const togSuccess = () => {
    setShowSuccess(!showSuccess)
  }

  const closeSuccess = () => {
    setSuccess(false)
    fetchCreds()
  }

  const togError = () => {
    setShowError(!showError)
  }

  const selectedApptSys = (apptSysTypes || []).find(x => x.key === apptSysName);

  return (
    <>
      <Modal isOpen={showSuccess} toggle={togSuccess}>
        <Success
          message="Credential saved successfully !"
          close={closeSuccess}
        />
      </Modal>
      <Modal isOpen={showError} toggle={togError}>
        <Error message={errorMsg} closeModal={togError} />
      </Modal>
      {apptSysTypes.length > 0 && (
        <Card>
          <CardBody>
            <LoadingOverlay active={formLoading} spinner>
              {isEdit && (
                <h5 className="mb-4 text-primary">Update Credential</h5>
              )}
              {!isEdit && (
                <h5 className="mb-4 text-primary">Create New Credential</h5>
              )}
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  save()
                  return false
                }}
              >
                <Row className="mb-4">
                  <Col md={4}>
                    <Label
                      htmlFor="horizontal-firstname-Input"
                      className=" col-form-label text-align-right"
                    >
                      Appointment System
                    </Label>
                  </Col>
                  <Col sm={6}>
                    <select
                      value={apptSysName}
                      disabled={isEdit}
                      name="apptSysName"
                      className="form-control"
                      onChange={e => {
                        handleSelectGroup(e)
                      }}
                    >
                      <option value={null}>Select</option>
                      {apptSysTypes.map((item, index) => {
                        return (
                          <option value={item.key} key={index}>
                            {item.name}
                          </option>
                        )
                      })}
                    </select>
                  </Col>
                </Row>

                {selectedApptSys?.cred_fields?.length > 0 ? (
                  <GroupFlexCred
                    creds={creds}
                    credFields={selectedApptSys.cred_fields}
                    isEdit={true}
                    setCreds={setCreds}
                    updateCreds={updateCreds}
                    setUpdateCreds={setUpdateCreds}
                    deleteCreds={deleteCreds}
                    setDeleteCreds={setDeleteCreds}
                  />
                ) : (
                  <GroupCred
                    creds={creds}
                    isEdit={true}
                    setCreds={setCreds}
                    updateCreds={updateCreds}
                    setUpdateCreds={setUpdateCreds}
                    deleteCreds={deleteCreds}
                    setDeleteCreds={setDeleteCreds}
                  />
                )}

                <Row className="mt-3">
                  <Col md={4}></Col>
                  <Col md={8}>
                    <div className="d-flex justify-content-end gap-2">
                      <Button
                        type="submit"
                        color="primary"
                        className="btn btn-sm"
                        disabled={isEdit
                          ? (updateCreds?.length === 0 && deleteCreds?.length === 0)
                          : (creds?.length === 0)
                        }
                      >
                        Save
                      </Button>
                      <Button
                        type="button"
                        color="secondary"
                        className="btn btn-secondary btn-sm"
                        onClick={onCancel}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </LoadingOverlay>
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default CredForm
